// extracted by mini-css-extract-plugin
module.exports = {"entity":"Entity_entity__2-jFH","gridContainer":"Entity_gridContainer__3MLPu","icon":"Entity_icon__1NJxV","content":"Entity_content__b8jTc","value":"Entity_value__pOojd"};